import { InfoMessageProps } from './types';
import WarningIcon from '../../../assets/icons/warningIcon.svg?react';
import GreenAlertIcon from '../../../assets/icons/greenAlertIcon.svg?react';
import { Stack, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledStan = styled('span')(({ theme }) => ({
  color: theme.palette.green.main,
}));

export const InfoMessage: React.FC<InfoMessageProps> = ({
  type,
  upperText,
  bottomText,
  chargingTime,
}) => {
  const { t } = useTranslation();
  const renderIcon = (type: string) => {
    switch (type) {
      case 'warning':
        return <WarningIcon width={24} height={24} />;
      case 'charging':
        return <GreenAlertIcon width={24} height={24} />;
      default:
        break;
    }
  };
  return (
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: '24px 1fr',
        gap: { xs: '15px' },
      }}
    >
      {renderIcon(type)}
      <Stack>
        <Typography variant="body1" color="common.white">
          {t(upperText)}
          {type === 'charging' ? (
            <>
              :{' '}
              <StyledStan>
                {chargingTime} {t('orderPage.minutes')}
              </StyledStan>
            </>
          ) : (
            ''
          )}
        </Typography>
        <Typography
          variant="body1"
          color="common.white"
          sx={{ marginTop: { xs: '8px' } }}
        >
          {t(bottomText)}
        </Typography>
      </Stack>
    </Stack>
  );
};
